<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 7.5,12.004h15.75 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 19.5,15.754l3.75-3.75l-3.75-3.75 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 15.75,16.5V21c0.036,0.79-0.574,1.461-1.364,1.5H2.113 c-0.79-0.04-1.399-0.71-1.363-1.5V3C0.714,2.21,1.323,1.539,2.113,1.5h12.273c0.79,0.039,1.4,0.71,1.364,1.5v4.5"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
export default {
  name: "IconLogout",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>